import { computed } from 'vue';
import useFeatureFlags from '@/composables/useFeatureFlags';

// Stream's dedicated Modulr GBP range, which the platform migrates companies to. '040072' is
// the shared range that it replaces. A company that holds this sort code needs to know.
export const NEW_MODULR_SORT_CODE = '043478';

// The company sort code comes from useFeatureFlags, which owns every app_features read. An unset
// value means the old shared range, so an absent key correctly shows nothing.
export default () => {
  const { modulrGbpSortCode } = useFeatureFlags();

  return { isOnNewModulrSortCode: computed(() => modulrGbpSortCode.value === NEW_MODULR_SORT_CODE) };
};
